<br />

@if (!dateTimePicker) {
  <input matInput #input [min]="minDateValue" [max]="maxDateValue" [matDatepicker]="picker" name="value"
    (focusout)="focusOut(value)" [placeholder]="checkPlaceholder('WebGalis_Core_Choose_Date')" (click)="picker.open()"
    [(ngModel)]="value" (ngModelChange)="onTextChange($event)" class="sem-text-box sem-date-picker"
    [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }"
    [disabled]="checkForDisabled(getAttribute('name')) || setDisabled || dfms?.isFormReadOnly == true"
    (keyup.enter)="focusOut(value);picker.close();">
    <!-- [disabled]="true"-->
    <mat-datepicker-toggle matSuffix [for]="picker"
      [disabled]="checkForDisabled(getAttribute('name')) || setDisabled || dfms?.isFormReadOnly == true">
    </mat-datepicker-toggle>
    <mat-datepicker (opened)="onPickerOpened()" (closed)="onPickerClosed()"
      [disabled]="checkForDisabled(getAttribute('name')) || setDisabled || dfms?.isFormReadOnly == true"
    #picker></mat-datepicker>
    <p class="binding-prop-name">{{getAttribute('name')}}</p>
  }


  @if (dateTimePicker) {
    <input [owlDateTime]="dt2" placeholder="Date Time"
      matInput2 #input2 [min]="minDateValue" [max]="maxDateValue" name="value"
      [placeholder]="checkPlaceholder('WebGalis_Core_Choose_Date')"
    [(ngModel)]="value" (ngModelChange)="onTextChange($event)" class="sem-text-box sem-date-picker"
    [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }"
    [disabled]="checkForDisabled(getAttribute('name')) || setDisabled || dfms?.isFormReadOnly == true" [owlDateTimeTrigger]="dt2">
      <owl-date-time #dt2></owl-date-time>
    }
